(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ndp-preview-link')) {
    customElements.define('ndp-preview-link', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        const root = this.closest('product-info');
        const button = this.querySelector('button');
        const samples = root?.querySelectorAll('.product__media-list .product__media-toggle');
        if (!button || !samples || samples.length < 2) return;
        this.bound = true;
        button.hidden = false;
        button.addEventListener('click', () => {
          const target = root.querySelectorAll('.product__media-list .product__media-toggle')[1];
          if (!target) return;
          const modal = document.querySelector(target.closest('modal-opener').dataset.modal);
          target.click();
          if (modal) modal.openedBy = button;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndp-conversion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ndp-offer-choice')) customElements.define('ndp-offer-choice', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const info = this.closest('product-info');
      const form = info?.querySelector('product-form form');
      if (!form) return;
      this.ready = true;
      this.querySelector('fieldset').hidden = false;
      const sync = () => {
        const selected = this.querySelector('input:checked');
        form.querySelector('[name=id]').value = selected.value;
        const price = info.querySelector('.ndpc-price > strong');
        if (price) price.textContent = selected.dataset.price;
        const button = form.querySelector('[type=submit] > span');
        if (button) button.textContent = selected.hasAttribute('data-bundle') ? this.dataset.addBundle : this.dataset.addSingle;
        const sticky = document.querySelector('.ndpc-sticky > span');
        if (sticky) sticky.textContent = selected.dataset.price;
        const finalPrice = document.querySelector('.ndpc-final .ndpc-offer-price');
        if (finalPrice) finalPrice.textContent = selected.dataset.price;
        const finalName = document.querySelector('[data-final-name]');
        if (finalName) finalName.textContent = selected.dataset.label;
        const format = info.querySelector('[data-ndpc-format]');
        if (format) format.textContent = selected.hasAttribute('data-bundle') ? format.dataset.bundle : format.dataset.single;
        const stats = info.querySelector('.ndpc-stats');
        if (stats) stats.textContent = selected.hasAttribute('data-bundle') ? this.dataset.statsBundle : this.dataset.statsSingle;
        this.querySelector('[data-choice-status]').textContent = selected.dataset.label + ' · ' + selected.dataset.price;
      };
      this.addEventListener('change', sync);
      sync();
    }
  });

  if (!customElements.get('ndp-conversion')) {
    customElements.define('ndp-conversion', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const body = this.querySelector('.ndpc-lightbox-body');
        const close = this.querySelector('.ndpc-close');
        const zoom = this.querySelector('.ndpc-zoom');

        const links = Array.from(this.querySelectorAll('[data-ndpc-preview]'));
        const counter = this.querySelector('.ndpc-counter');
        let active = 0;
        let startTouch = null;
        const showPage = index => {
          active = (index + links.length) % links.length;
          const link = links[active];
          const thumbnail = link.querySelector('img');
          const preview = document.createElement('img');
          preview.src = link.href;
          preview.alt = thumbnail?.alt || '';
          preview.width = thumbnail?.naturalWidth || 800;
          preview.height = thumbnail?.naturalHeight || 1100;
          preview.draggable = false;
          body.replaceChildren(preview);
          body.classList.remove('is-zoomed');
          zoom?.setAttribute('aria-pressed', 'false');
          body.scrollTop = 0;
          body.scrollLeft = 0;
          counter.textContent = (active + 1) + ' / ' + links.length + ' · ' + link.querySelector('.ndpc-page-number').textContent + ' — ' + link.querySelector('.ndpc-preview-title').textContent;
        };
        zoom?.addEventListener('click', () => {
          const enlarged = body.classList.toggle('is-zoomed');
          zoom.setAttribute('aria-pressed', String(enlarged));
        });
        this.querySelector('.ndpc-prev')?.addEventListener('click', () => showPage(active - 1));
        this.querySelector('.ndpc-next')?.addEventListener('click', () => showPage(active + 1));
        dialog?.addEventListener('keydown', event => {
          if (body.classList.contains('is-zoomed') || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            showPage(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        body?.addEventListener('touchstart', event => {
          startTouch = event.touches.length === 1 && !body.classList.contains('is-zoomed')
            ? {x:event.touches[0].clientX, y:event.touches[0].clientY} : null;
        }, {passive:true});
        body?.addEventListener('touchend', event => {
          if (!startTouch || event.touches.length || body.classList.contains('is-zoomed')) { startTouch = null; return; }
          const touch = event.changedTouches[0];
          const dx = touch.clientX - startTouch.x;
          const dy = touch.clientY - startTouch.y;
          startTouch = null;
          if (Math.abs(dx) >= 60 && Math.abs(dx) > Math.abs(dy) * 1.5) showPage(active + (dx < 0 ? 1 : -1));
        }, {passive:true});
        body?.addEventListener('touchcancel', () => { startTouch = null; }, {passive:true});
        this.controller = new AbortController();
        const openPreview = (opener, index = 0) => {
          if (!links.length || !dialog?.showModal) return false;
          showPage(index);
          this.opener = opener;
          if (!dialog.open) dialog.showModal();
          close.focus();
          return true;
        };
        document.querySelectorAll('[data-ndpc-open-preview]').forEach(trigger => {
          if (!links.length || !dialog?.showModal) return;
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', dialog.id);
          trigger.addEventListener('click', event => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            if (openPreview(trigger)) event.preventDefault();
          }, {signal:this.controller.signal});
        });
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-ndpc-preview]');
          if (!link || !dialog?.showModal) return;
          event.preventDefault();
          openPreview(link, links.indexOf(link));
        }, {signal:this.controller.signal});
        close?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog?.addEventListener('close', () => { startTouch = null; this.opener?.focus(); });
        const sourceProductForm = document.querySelector('product-info product-form');
        const sourceForm = sourceProductForm?.querySelector('form');
        const sourceButton = sourceForm?.querySelector('[type="submit"]');
        const finalAdd = this.querySelector('[data-final-add]');
        const finalError = this.querySelector('[data-final-error]');
        if (sourceForm?.requestSubmit && sourceButton && finalAdd) {
          const defaultLabel = finalAdd.textContent;
          const syncPurchase = () => {
            const busy = sourceButton.classList.contains('loading');
            finalAdd.disabled = sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true' || busy;
            finalAdd.setAttribute('aria-busy', String(busy));
            const selected = document.querySelector('ndp-offer-choice input:checked');
            finalAdd.textContent = busy ? finalAdd.dataset.adding : selected ? sourceButton.querySelector('span').textContent : defaultLabel;
            const error = sourceProductForm.querySelector('.product-form__error-message-wrapper');
            const message = error && !error.hidden ? error.querySelector('.product-form__error-message')?.textContent.trim() : '';
            finalError.hidden = !message;
            if (finalError.textContent !== (message || '')) finalError.textContent = message || '';
          };
          finalAdd.hidden = false;
          if (sourceButton.hasAttribute('aria-haspopup')) finalAdd.setAttribute('aria-haspopup', sourceButton.getAttribute('aria-haspopup'));
          const change = this.querySelector('[data-final-change]');
          if (change) change.textContent = change.dataset.readyLabel;
          finalAdd.addEventListener('click', () => {
            if (sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true') return;
            sourceForm.requestSubmit(sourceButton);
            syncPurchase();
          }, {signal:this.controller.signal});
          this.purchaseObserver = new MutationObserver(syncPurchase);
          this.purchaseObserver.observe(sourceProductForm, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','class','hidden']});
          syncPurchase();
        }
        this.querySelector('[data-ndpc-select-bundle]')?.addEventListener('click', event => {
          const choice = document.querySelector('ndp-offer-choice');
          const radio = choice?.querySelector('input[data-bundle]');
          if (!choice?.ready || !radio || event.ctrlKey || event.metaKey) return;
          event.preventDefault(); radio.checked = true;
          radio.dispatchEvent(new Event('change', {bubbles:true}));
          choice.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          radio.focus({preventScroll:true});
        }, {signal:this.controller.signal});
        const buyArea = document.querySelector('.ndpc-intro');
        const sticky = this.querySelector('.ndpc-sticky');
        if (buyArea && sticky && 'IntersectionObserver' in window) {
          const topOffer = buyArea.closest('.product__info-container') || buyArea;
          const ending = this.querySelector('.ndpc-final');
          let pastOffer = false, reachedEnding = false;
          this.observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
              if (entry.target === topOffer) pastOffer = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              if (entry.target === ending) reachedEnding = entry.isIntersecting || entry.boundingClientRect.top < 0;
            }
            sticky.hidden = !pastOffer || reachedEnding;
          }, {rootMargin:'0px 0px 0px 0px'});
          this.observer.observe(topOffer);
          if (ending) this.observer.observe(ending);
        }
      }
      disconnectedCallback() { this.observer?.disconnect(); this.purchaseObserver?.disconnect(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndp-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ndp-cookie-settings')) customElements.define('ndp-cookie-settings', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return; this.ready=true;
    const button=this.querySelector('[data-cookie-open]'), error=this.querySelector('[data-cookie-error]');
    button.addEventListener('click',async()=>{
      const label=button.textContent; button.disabled=true; button.textContent=button.dataset.loading; error.hidden=true;
      try {
        if (!window.privacyBanner?.showPreferences) {
          await new Promise((resolve,reject)=>{
            const script=document.createElement('script');
            script.src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
            script.async=true;
            const timeout=setTimeout(()=>{script.remove(); reject(new Error('privacy timeout'));},10000);
            script.onload=()=>{clearTimeout(timeout); resolve();};
            script.onerror=()=>{clearTimeout(timeout); script.remove(); reject(new Error('privacy unavailable'));};
            document.head.appendChild(script);
          });
        }
        await window.privacyBanner.showPreferences();
      } catch { error.hidden=false; }
      finally {button.disabled=false; button.textContent=label;}
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ndp-story-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ndp-story')) customElements.define('ndp-story', class extends HTMLElement {
  connectedCallback() {
    if(this.abort) return;
    this.abort = new AbortController();
    const options={signal:this.abort.signal};
    this.preview=this.querySelector('.nbs-preview-dialog');
    this.legal=this.querySelector('.nbs-legal-dialog');
    this.previews=[...this.querySelectorAll('[data-format-panel="mobile"] [data-preview]')];
    this.sticky=this.querySelector('.nbs-sticky');
    this.index=0;
    this.addEventListener('click',event=>{
      const target=event.target.closest('a,button');
      if(!target||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
      if(target.matches('[data-preview]') && this.preview.showModal){event.preventDefault();this.index=this.previews.indexOf(target);this.showPreview();this.openDialog(this.preview,target);}
      if(target.matches('[data-preview-format]')){
        const format=target.dataset.previewFormat;
        this.querySelectorAll('[data-preview-format]').forEach(button=>button.setAttribute('aria-pressed',String(button===target)));
        this.querySelectorAll('[data-format-panel]').forEach(panel=>panel.hidden=panel.dataset.formatPanel!==format);
        this.previews=[...this.querySelectorAll('[data-format-panel="'+format+'"] [data-preview]')];
        this.index=0;
      }
      if(target.matches('[data-demo-answer]')){
        const card=target.closest('.nbs-demo-card');
        card.querySelectorAll('[data-demo-answer]').forEach(button=>button.setAttribute('aria-pressed',String(button===target)));
        const result=card.querySelector('template[data-demo-result="'+target.dataset.demoAnswer+'"]');
        card.querySelector('.nbs-demo-feedback').replaceChildren(result.content.cloneNode(true));
        card.querySelector('[data-demo-own]').hidden=false;
      }
      if(target.matches('[data-story-cart]')){const cart=document.querySelector('cart-drawer');if(cart?.open){event.preventDefault();cart.open(target);}}
      if(target.matches('[data-close]')) target.closest('dialog').close();
      if(target.matches('[data-prev],[data-next]')){this.index=(this.index+(target.matches('[data-next]')?1:-1)+this.previews.length)%this.previews.length;this.showPreview();}
    },options);
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(!link||event.defaultPrevented||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!this.legal.showModal) return;
      const url=new URL(link.href,location.href);
      if(url.origin!==location.origin) return;
      const drawer=link.closest('cart-drawer');
      if(drawer && (url.pathname==='/collections/all'||url.pathname.startsWith('/products/'))){
        event.preventDefault();drawer.close();
        if(url.pathname.startsWith('/products/')){
          const section=this.querySelector(url.pathname.includes('/pakiet-')?'#story-upgrade':'#story-preview');
          section?.scrollIntoView({block:'start'});
        }
        return;
      }
      const template=[...this.querySelectorAll('template[data-legal-path]')].find(item=>item.dataset.legalPath===url.pathname);
      if(!template) return;
      event.preventDefault();
      this.legal.querySelector('[data-legal-title]').textContent=template.dataset.title;
      this.legal.querySelector('.nbs-legal-content').replaceChildren(template.content.cloneNode(true));
      if(!this.legal.open)this.openDialog(this.legal,link);
      this.legal.querySelector('.nbs-legal-content').scrollTop=0;
    },options);
    [this.preview,this.legal].forEach(dialog=>{
      dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.dialogTrigger?.focus({preventScroll:true});this.updateSticky();},options);
      dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}},options);
    });
    this.preview.addEventListener('keydown',event=>{if((event.key==='ArrowRight'||event.key==='ArrowLeft')){event.preventDefault();this.index=(this.index+(event.key==='ArrowRight'?1:-1)+this.previews.length)%this.previews.length;this.showPreview();}},options);
    let scheduled=false;
    const refresh=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;this.updateSticky();});};
    window.addEventListener('scroll',refresh,{...options,passive:true});
    window.addEventListener('resize',refresh,options);
    this.updateSticky();
  }
  openDialog(dialog,trigger){this.dialogTrigger=trigger;this.previousOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';this.sticky.hidden=true;}
    showPreview(){
      const link=this.previews[this.index];
      const template=this.querySelector('template[data-reader-key="'+link.dataset.reader+'"]');
      const holder=this.preview.querySelector('[data-reader-content]');
      holder.replaceChildren(template.content.cloneNode(true));
      this.preview.querySelector('.nbs-reader-hint').textContent=link.dataset.previewHint;
      const scroll=this.preview.querySelector('.nbs-reader-scroll');
      scroll.scrollTop=0;
      this.preview.querySelector('[data-counter]').textContent=`${this.index+1} / ${this.previews.length} · ${link.dataset.label}`;
    }
  updateSticky(){const marker=this.querySelector('#story-preview');if(!marker||!this.sticky)return;const visible=element=>{const rect=element.getBoundingClientRect();return rect.top<innerHeight&&rect.bottom>0;};this.sticky.hidden=innerWidth>=750||marker.getBoundingClientRect().bottom>0||[...this.querySelectorAll('.nbs-order-card,.nbs-upgrade,.nbs-final,dialog[open]')].some(visible)||!!document.querySelector('cart-drawer.active')||visible(document.querySelector('.ndp-footer')||this.querySelector('.nbs-final'));}
  disconnectedCallback(){this.abort?.abort();this.abort=null;if(this.preview?.open||this.legal?.open)document.documentElement.style.overflow=this.previousOverflow||'';}
});


  } catch(e) { console.error(e); }
})();
})();
